/* ============================================
   POSEALIGN™ — Custom Theme JavaScript
   File: assets/posealign.js
   ============================================ */
 
document.addEventListener('DOMContentLoaded', function () {
 
  /* ------------------------------------------
     1. ROTATING ANNOUNCEMENT BAR
     Shows 3 rotating messages at the top
  ------------------------------------------ */
  var msgs = document.querySelectorAll('.pa-announcement__msg');
  if (msgs.length > 0) {
    var currentMsg = 0;
    msgs[0].classList.add('active');
    setInterval(function () {
      msgs[currentMsg].classList.remove('active');
      currentMsg = (currentMsg + 1) % msgs.length;
      msgs[currentMsg].classList.add('active');
    }, 3500);
  }
 
  /* ------------------------------------------
     2. STICKY ADD TO CART BAR
     Appears when the hero section scrolls out of view
  ------------------------------------------ */
  var hero = document.querySelector('.pa-hero');
  var stickyAtc = document.querySelector('.pa-sticky-atc');
 
  if (hero && stickyAtc) {
    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyAtc.classList.add('visible');
          } else {
            stickyAtc.classList.remove('visible');
          }
        });
      },
      { threshold: 0 }
    );
    heroObserver.observe(hero);
  }
 
  /* ------------------------------------------
     3. STICKY ATC — ADD TO CART BUTTON ACTION
     Clicks the main page's Add to Cart button
  ------------------------------------------ */
  var stickyBtn = document.querySelector('.pa-sticky-atc__btn');
  var mainForm = document.querySelector('form[action="/cart/add"]');
 
  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', function () {
      var mainBtn = mainForm.querySelector('[type="submit"]');
      if (mainBtn) {
        mainBtn.click();
      } else {
        mainForm.submit();
      }
    });
  }
 
  /* ------------------------------------------
     4. FAQ ACCORDION
     Opens/closes FAQ answers on click
  ------------------------------------------ */
  var faqItems = document.querySelectorAll('.pa-faq__item');
 
  faqItems.forEach(function (item) {
    var question = item.querySelector('.pa-faq__question');
    if (question) {
      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Close all items
        faqItems.forEach(function (i) {
          i.classList.remove('open');
        });
        // Open clicked item if it was closed
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    }
  });
 
  /* ------------------------------------------
     5. BEFORE/AFTER IMAGE SLIDER
     Drag or touch to reveal transformation
  ------------------------------------------ */
  var baWrapper = document.querySelector('.pa-ba__wrapper');
  if (baWrapper) {
    var baAfter  = baWrapper.querySelector('.pa-ba__after');
    var baDivider = baWrapper.querySelector('.pa-ba__divider');
    var isDragging = false;
    var currentPercent = 50;
 
    function setSliderPosition(percent) {
      percent = Math.max(5, Math.min(95, percent));
      currentPercent = percent;
      if (baAfter)   baAfter.style.width = percent + '%';
      if (baDivider) baDivider.style.left = percent + '%';
    }
 
    function getPercent(clientX) {
      var rect = baWrapper.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }
 
    // Mouse events
    baWrapper.addEventListener('mousedown', function (e) {
      isDragging = true;
      setSliderPosition(getPercent(e.clientX));
      e.preventDefault();
    });
 
    document.addEventListener('mousemove', function (e) {
      if (isDragging) setSliderPosition(getPercent(e.clientX));
    });
 
    document.addEventListener('mouseup', function () {
      isDragging = false;
    });
 
    // Touch events (mobile)
    baWrapper.addEventListener('touchstart', function (e) {
      isDragging = true;
      setSliderPosition(getPercent(e.touches[0].clientX));
    });
 
    document.addEventListener('touchmove', function (e) {
      if (isDragging) setSliderPosition(getPercent(e.touches[0].clientX));
    });
 
    document.addEventListener('touchend', function () {
      isDragging = false;
    });
 
    // Initialize at 50%
    setSliderPosition(50);
  }
 
});